import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cloudtalk = defineConnector({
  identifier: "cloudtalk",
  name: "CloudTalk",
  tagLine: "Business calling platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://my\\.cloudtalk\\.io/api/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Find your CloudTalk API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [CloudTalk authentication docs](https://developers.cloudtalk.io/docs#authentication) and create API credentials in your CloudTalk account settings. Copy the username and API key for the account you want to use.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your CloudTalk account settings.",
        },
        {
          kind: "input",
          label: "ID",
          required: true,
          target: { kind: "secrets", field: "username" },
          placeholder: "E1ZH****************RRM",
          helperText: "Your CloudTalk API Access ID.",
        },
        {
          kind: "input",
          label: "Key",
          required: true,
          target: { kind: "secrets", field: "password" },
          placeholder: "bQI*******************************eZ",
          helperText: "Your CloudTalk API Access Key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://my.cloudtalk.io/api/contacts/index.json?limit=1",
  },
});
